import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MsalContext, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { configuration } from "../authConfig";

import './NavMenu.css';
import logo from '../assets/logo.png';

export class NavMenu extends Component {
  static displayName = NavMenu.name;
  static contextType = MsalContext;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white navbar-light border-bottom box-shadow mb-3 color-nav" dark>
          <Container>
            <NavbarBrand tag={Link} to="/" className="text-light">
              <div className="row">
                <div className="col-md-6 text-center">
                  <img src={logo} alt="" className="nav-logo" />
                </div>
                <div className="col-md-12 text-center">
                  <div className="logo-text text-light text-start float-left">STC | Immucert Admin {configuration.version}</div>
                </div>
              </div>
            </NavbarBrand>
            {/*<NavbarBrand tag={Link} to="/" className="text-light">Immucert Admin</NavbarBrand>*/}
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar >
              <ul className="navbar-nav flex-grow">
                <AuthenticatedTemplate>
                  <NavItem>
                    {this.context !== undefined && this.context.accounts !== undefined && this.context.accounts.length > 0 && <NavLink className="text-light">Hello: {this.context.accounts[0].name}</NavLink>}
                  </NavItem>
                  <NavItem>
                    <SignOutButton />
                  </NavItem>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <NavItem>
                    <SignInButton />
                  </NavItem>
                </UnauthenticatedTemplate>
              </ul>
              <ul className="navbar-nav flex-grow-1">
                <NavItem>
                  <NavLink tag={Link} className="text-light" to="/">Home</NavLink>
                </NavItem>
                <AuthenticatedTemplate>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/logs">Logs</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/sender">Send Request</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-light" to="/details">Recent</NavLink>
                  </NavItem>
                </AuthenticatedTemplate>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
